import { Group, FabricObject, StaticCanvas } from 'fabric';

export function walkObjects(root: StaticCanvas | Group, fn: (obj: FabricObject) => void): void {
  for (const obj of root.getObjects()) {
    fn(obj);
    if (obj instanceof Group) walkObjects(obj, fn);
  }
}

export function findObject(
  root: StaticCanvas | Group,
  predicate: (obj: FabricObject) => boolean
): FabricObject | undefined {
  for (const obj of root.getObjects()) {
    if (predicate(obj)) return obj;
    if (obj instanceof Group) {
      const found = findObject(obj, predicate);
      if (found) return found;
    }
  }
  return undefined;
}
